import script from "./TabletSideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TabletSideNav.vue?vue&type=script&setup=true&lang=js"

import "./TabletSideNav.vue?vue&type=style&index=0&id=4b1085aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1085aa"]])

export default __exports__